<script setup lang="ts">
import UserState from "@/stores/UserState";
import LastDrawingsSection from "@/components/homepage/LastDrawingsSection.vue";
import InProgressProjectsSection from "@/components/homepage/InProgressProjectsSection.vue";
</script>

<template>
  <div
    class="my-5 mx-3 mx-md-4 mx-lg-5 px-sm-2 px-md-4 px-lg-5 d-flex justify-content-center"
  >
    <div
      v-if="UserState.data"
      class="col-12 col-xl-11 d-flex flex-column gap-4 gap-lg-5"
    >
      <div class="h2 text-center">
        {{ $t("hello") }}, {{ UserState.data.full_name }}
      </div>

      <LastDrawingsSection />

      <InProgressProjectsSection />
    </div>
  </div>
</template>
